/**
 * useChat Composable
 *
 * Wraps the chatbot Pinia store with a clean, minimal API.
 */
import { computed } from 'vue';
import { useChatbotStore } from '../stores/chatbot.store';
import { useAuthStore } from '@/domains/auth';
import { ITINERARY_QUICK_ACTION_ID } from '../models';
export function useChat() {
    const store = useChatbotStore();
    const authStore = useAuthStore();
    const canCreateItineraries = computed(() => authStore.currentOrgType !== 'provider');
    const quickActions = computed(() => canCreateItineraries.value
        ? store.quickActions
        : store.quickActions.filter((action) => action.id !== ITINERARY_QUICK_ACTION_ID));
    return {
        isOpen: computed(() => store.isOpen),
        isMinimized: computed(() => store.isMinimized),
        messages: computed(() => store.messages),
        isTyping: computed(() => store.isTyping),
        streamingMessageId: computed(() => store.streamingMessageId),
        quickActions,
        canCreateItineraries,
        shouldShowWelcome: computed(() => store.shouldShowWelcome),
        shouldShowQuickActions: computed(() => store.shouldShowQuickActions),
        open: () => store.openWidget(),
        close: () => store.closeWidget(),
        minimize: () => store.minimizeWidget(),
        toggle: () => store.toggleWidget(),
        send: (content) => store.sendMessage(content),
        sendQuickAction: (action) => store.sendQuickAction(action),
        clear: () => store.clearConversation(),
    };
}
export default useChat;
